export default __webpack_public_path__ + "static/media/parkingmap3.81da2e63.png";